import React from 'react'
import {CreateGuesser} from '@api-platform/admin'
import {TextInput} from 'react-admin';
import {useTranslation} from "react-i18next";


function Create(props) {
    const {t} = useTranslation()

    return (
        <CreateGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <TextInput source="code" label={t('admin.code')}/>
        </CreateGuesser>
    )
}

export default Create
